export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AssociateOrgsConfig.vue?vue&type=template&id=124fa853&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/usage/AssociateOrgsConfig.vue?vue&type=template&id=124fa853&scoped=true&
// module id = 1449
// module chunks = 0